import React from 'react';
import { ButtonProps, ButtonVariant } from './Button.types';
import { StyledButton } from './Button.styles';

const Button = ({
  variant = ButtonVariant.Filled,
  title,
  onClick,
  disabled,
  style,
  className,
  size = 'medium',
  textColor = 'white',
  buttonColor = '#278ADA',
  hoverTextColor = 'white',
  type = 'button',
}: Partial<ButtonProps>) => {
  return (
    <StyledButton
      variant={variant}
      size={size}
      onClick={onClick}
      disabled={disabled}
      textColor={textColor}
      buttonColor={buttonColor}
      hoverTextColor={hoverTextColor}
      style={style}
      type={type}
      className={className}
    >
      {title}
    </StyledButton>
  );
};

export default Button;
